var ValueJS = ValueJS || {};

ValueJS.ScrollToNextSection = function() {

    var _initialized = false;

    var _init = function() {

        $('.scroll-next-section').on('click', function(e) {
            e.preventDefault();
            let cta = $(this);
            let nextSection = cta.parents('.section').next('.section');
            ValueJS.SmoothScroll.scroll(nextSection);
        })

        if (!_initialized) {
            _initialized = true;
        }
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();}
    };

}();

$(function() {
    ValueJS.ScrollToNextSection.init();
});
